import { useEffect, useState } from 'react'

import Confetti from 'react-confetti'
import React from 'react';
import {Snackbar, Alert } from '@mui/material';

const Congratulations = ({ fire, message }) => {
    const [confetti, setConfetti] = useState(0);
    const [congratulations, setCongratulations] = useState(false);

    useEffect(() => {
         if (fire) {
             setCongratulations(message);
 
             setConfetti(100);
 
             setTimeout(() => {
                 setConfetti(0)
             }, 3000);
         }
 
     }, [fire])

    return (
        <>
            <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                numberOfPieces={confetti}
            />

            <Snackbar open={congratulations} autoHideDuration={3000} onClose={() => setCongratulations(false)}>
                <Alert elevation={6} variant="filled" onClose={() => setCongratulations(false)} severity="success">
                    {congratulations}
                </Alert>
            </Snackbar>
        </>
    );
};

export default Congratulations;